export default __webpack_public_path__ + "static/media/favicon.c1ad7af8.ico";